import TableDailyGeneratedQRCount from './table-daily-generated-qr.container';

export default TableDailyGeneratedQRCount;
